import { Button } from "@mui/material";
// import { colorSecondary } from "@/constants/colors";
import { TCustomButtonProps } from "./CustomButton.props";

const CustomButton = ({ ...props }: TCustomButtonProps): JSX.Element => {
	return (
		<Button
			variant="outlined"
			type="button"
			{...props}
			sx={{
				height: 33,
				// color: colorSecondary,
				// borderColor: colorSecondary,
				fontSize: 11,
				overflow: "hidden",
				"&:hover": {
					borderColor: "inherit",
				},
				...props.sx,
			}}
		/>
	);
};

export default CustomButton;
